
const allergyFilterBtns = document.querySelectorAll('[data-allergy-filter]');

const products = document.querySelectorAll('[data-product-bundle-item]');

let activeFilters = []

const filterProducts = () => {
    allergyFilterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const filter = btn.dataset.allergyFilter;

            btn.classList.toggle('active');

            // If the filter is already active, remove it
            if (activeFilters.includes(filter)) {
                activeFilters = activeFilters.filter((f) => f !== filter);
            } else {
                // Otherwise, add it
                activeFilters.push(filter);
            }

            products.forEach((product) => {
                const allergyList = product.querySelector("[data-allergy-list]");

                const allergyListData = JSON.parse(allergyList.textContent);

                // Check if the product matches all active filters
                const matchesAllFilters = activeFilters.every(
                    (filter) =>
                        allergyListData[filter] === "False" || allergyListData[filter] === "True, precaution"
                );

                // If the product does not match all filters, hide it
                if (!matchesAllFilters) {
                    product.style.display = "none";
                } else {
                    product.style.display = "flex";
                }
            });
        });
    });
}

const init = () => {
    filterProducts();
};

init();


//reload page if the customer returns from browser back button

window.addEventListener("pageshow", function(event) {
    if (event.persisted) {
        sessionStorage.clear();
        location.reload();
    }
});



(() => {
    const node = document.querySelector('[data-product-bundle]');
    //const defaultPriceMessage = node.querySelector('[data-total-price]').innerHTML;
    const bundleMinimumItems = parseInt(node.dataset.productBundleMinimumItems);
    const bundleLimit = parseInt(node.dataset.productBundleLimit);
    const bundleMealsLimit = parseInt(node.dataset.productBundleMealsLimit);
    const initialDiscount = parseInt(node.dataset.productBundleInitialDiscount);
    const bundleParentId = parseInt(node.dataset.parentBundleId);
    const jsonBundleData = JSON.parse(window.bundleStrings.jsonBundleData);
    let keys = [];
    let unitCounter = '';
    if(jsonBundleData){
        keys = Object.keys(jsonBundleData) ?? [];
        const validKeys = ['items', 'portions'];
        unitCounter = validKeys.includes(keys[0]) ? keys[0] : '';
    }

    let DISCOUNTS,
        staticBundle = false;


    if (bundleLimit === 1  && bundleMinimumItems === 1) {
        let staticBundle = true
    }

    if (bundleMealsLimit) {
        DISCOUNTS = [
            {
                minimumItems: bundleMealsLimit,
                amount: initialDiscount,
                step: 1,
            },
        ];
    } else if (bundleLimit){
        DISCOUNTS = [
            {
                minimumItems: bundleMinimumItems,
                amount: initialDiscount,
                step: 1,
            },
        ];
    } else if (unitCounter){
        DISCOUNTS = [
            {
                minimumItems: jsonBundleData[unitCounter][0].minimumItems,
                amount: jsonBundleData[unitCounter][0].amount,
                step: 1,
            },
            {
                minimumItems: jsonBundleData[unitCounter][1].minimumItems,
                amount: jsonBundleData[unitCounter][1].amount,
                step: 2,
            },
            {
                minimumItems: jsonBundleData[unitCounter][2].minimumItems,
                amount: jsonBundleData[unitCounter][2].amount,
                step: 3,
            },
        ];
    }

    const percCont = document.querySelector('.product-mix-bundle__percentage-container');
    if (bundleLimit === 0 && bundleMealsLimit === 0 ) {
        percCont.classList.remove("hidden");
    }

    if(bundleMealsLimit !== 0 || unitCounter === 'portions') {
        const counterBox = document.querySelector('.product-bundle__select__text.meals');
        const counterBoxSticky = document.querySelector('.product-bundle__select__text-sticky.meals');
        const counterBoxStickyMobile = document.querySelector('.product-bundle__select__text-sticky-mobile.meals');
        const selectedText = document.querySelector('.product-bundle__selected__text.meals');
        selectedText?.classList.remove("hidden");
        counterBox?.classList.remove("hidden");
        counterBoxSticky?.classList.remove("hidden");
        counterBoxStickyMobile?.classList.remove("hidden");

    } else {
        const counterBox = document.querySelector('.product-bundle__select__text.packs');
        const counterBoxSticky = document.querySelector('.product-bundle__select__text-sticky.packs');
        const counterBoxStickyMobile = document.querySelector('.product-bundle__select__text-sticky-mobile.packs');
        const selectedText = document.querySelector('.product-bundle__selected__text.packs');
        counterBox?.classList.remove("hidden");
        counterBoxSticky?.classList.remove("hidden");
        counterBoxStickyMobile?.classList.remove("hidden");
        selectedText?.classList.remove("hidden");
    }

    const stickyCta = () => {
        const bundleCta = node.querySelector('[data-bundle-cta]');
        const stickyCta = document.querySelector('[data-sticky-cta]');
        if (bundleCta) {
            new IntersectionObserver(([entry]) => {
                stickyCta.classList.toggle('product-bundle__sticky--active', !entry.isIntersecting);
            }, {
                root: null,
                rootMargin: '0px',
                threshold: 0
            }).observe(bundleCta);
        }
    };

    const activeProductItem = (qty, item, qtySelector) => {
        const isActive = qty.dataset.value > 0;
        item.classList.toggle('product-bundle__item--active', isActive);
        qtySelector.classList.toggle('product-bundle__item__quantity-selector--active', isActive);
    };

    const updateQuantity = (qty, value) => {
        const maxQuantity = parseInt(qty.dataset.maxQuantity);
        const item = qty.closest('.product-bundle__item');
        const qtySelector = item.querySelector('.product-bundle__item__quantity-selector');
        const incrementButton = qtySelector.querySelector('[data-increment]');
        // const deSelector = qtySelector.querySelector('[data-deselector]');
        const totalQty = getTotalQty() - parseInt(qty.dataset.value);


        if (bundleLimit === 0 || totalQty + value <= bundleLimit) {
            qty.dataset.value = value;
            qty.textContent = value;
            activeProductItem(qty, item, qtySelector);
            incrementButton.classList.toggle('product-bundle__item__quantity-selector__button--disabled', value >= maxQuantity);
            /*deSelector.toggleAttribute("hidden", value === 0)*/
            updatePrice();
            updateMinimumAmount();
            updateTotalAmountQty();
            updateCta();
            mealCalculation();
        }

        if (staticBundle){
            qty.dataset.value = '1';
            qty.textContent = 1;
        }
    };



    const orderSummmery = (modalId) => {

        const modalBody = document.querySelector(`.${modalId}[data-summary-modal]`);
        modalBody.innerHTML = ''; // Clear previous content

        // Create the table element
        const table = document.createElement('table');
        table.classList.add('order-summary-table');
        table.style.width = '100%';
        table.style.borderCollapse = 'collapse';

        const removeEverything = () => {
            document.querySelectorAll('[data-quantity]').forEach(item => {
                if(!item.classList.contains('static')){
                    updateQuantity(item, 0);
                    document.getElementById('ModalClose-SelectedProductModal').click();
                    document.getElementById('ModalClose-SelectedProductModalMobile').click();
                }
            });
        };

            // Create the table header
        const thead = document.createElement('thead');
        const tr = document.createElement('tr');

        // Create individual headers
        const thProduct = document.createElement('th');
        thProduct.style.textAlign = "left";
        thProduct.style.padding = "8px";
        thProduct.style.borderBottom = "1px solid #000";
        thProduct.textContent = "Product";

        const thQuantity = document.createElement('th');
        thQuantity.style.textAlign = "center";
        thQuantity.style.padding = "8px";
        thQuantity.style.borderBottom = "1px solid #000";
        thQuantity.textContent = "Qty";

        const thRemoveAll = document.createElement('th');
        thRemoveAll.style.textAlign = "right";
        thRemoveAll.style.padding = "8px";
        thRemoveAll.style.borderBottom = "1px solid #000";
        thRemoveAll.style.cursor = "pointer";
        thRemoveAll.style.whiteSpace = "nowrap";
        thRemoveAll.textContent = "Remove All";
        // Create the new SVG element
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "12");
        svg.setAttribute("height", "12");
        svg.setAttribute("viewBox", "0 0 12 12");
        svg.setAttribute("fill", "none");
        svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

        const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path1.setAttribute("d", "M9.88911 5.44446V10.6667C9.88911 10.8508 9.73989 11 9.55578 11H2.44466C2.26057 11 2.11133 10.8508 2.11133 10.6667V5.44446");
        path1.setAttribute("stroke", "#2B2E2E");
        path1.setAttribute("stroke-linecap", "round");
        path1.setAttribute("stroke-linejoin", "round");

        const path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path2.setAttribute("d", "M4.88867 8.77779V5.44446");
        path2.setAttribute("stroke", "#2B2E2E");
        path2.setAttribute("stroke-linecap", "round");
        path2.setAttribute("stroke-linejoin", "round");

        const path3 = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path3.setAttribute("d", "M7.11133 8.77779V5.44446");
        path3.setAttribute("stroke", "#2B2E2E");
        path3.setAttribute("stroke-linecap", "round");
        path3.setAttribute("stroke-linejoin", "round");

        const path4 = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path4.setAttribute("d", "M11 3.22222H8.22223M8.22223 3.22222V1.33333C8.22223 1.14924 8.073 1 7.88889 1H4.11111C3.92702 1 3.77778 1.14924 3.77778 1.33333V3.22222M8.22223 3.22222H3.77778M1 3.22222H3.77778");
        path4.setAttribute("stroke", "#2B2E2E");
        path4.setAttribute("stroke-linecap", "round");
        path4.setAttribute("stroke-linejoin", "round");

// Append the paths to the SVG
        svg.appendChild(path1);
        svg.appendChild(path2);
        svg.appendChild(path3);
        svg.appendChild(path4);

// Append the SVG before the text "Remove All"
        thRemoveAll.textContent = ""; // Clear any existing text
        thRemoveAll.appendChild(svg); // Append the SVG
        thRemoveAll.appendChild(document.createTextNode(" All")); // Append the text


// Attach event listener instead of inline onclick
        thRemoveAll.addEventListener("click", removeEverything);

// Append headers to the row
        tr.appendChild(thProduct);
        tr.appendChild(thQuantity);
        tr.appendChild(thRemoveAll);

// Append row to the thead
        thead.appendChild(tr);

        table.appendChild(thead);

        // Create the table body
        const tbody = document.createElement('tbody');

        Array.from(document.querySelectorAll('.product-bundle__item--active [data-product]')).map((product, index, array) => {
            const qtyElement = product.closest('.product-bundle__item').querySelector('[data-quantity]');
            let qty = parseInt(qtyElement.dataset.value);
            const item = product.closest('.product-bundle__item');
            const imgSrc = product.closest('.product-bundle__item').querySelector('img')?.src;
            const vendor = product.closest('.product-bundle__item').querySelector('.bundle-product-type')?.textContent.trim();
            const title = product.closest('.product-bundle__item').querySelector('.bundle-product-title')?.textContent.trim();

            if(item.classList.contains('static')) {return}
            // Create table row
            const row = document.createElement('tr');

            row.innerHTML = `
            <td style="display: flex; align-items: center; gap: 10px; padding: 8px; position: relative; border-bottom: 1px solid #000;">
                <img src="${imgSrc}" alt="${title}" style="width: 50px; height: auto;">
                <div>
                    <p style="margin: 0; font-weight: 400;">${title}</p>
                </div>
                ${index < array.length - 1 ? `<div style="position: absolute; bottom: -5px; width: 100%; height: 1px; background: linear-gradient(to right, transparent 0%, #ccc 50%, transparent 100%); transform: rotate(-10deg);"></div>` : ''}
            </td>
            <td style="text-align: right; text-align: -moz-right; padding: 8px; border-bottom: 1px solid #000;">
                <div class="product-bundle__item__quantity-selector">
   
                    <button class="product-bundle__item__quantity-selector__btn qty-btn minus">
                        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M29 14C29 21.732 22.5081 28 14.5 28C6.49187 28 0 21.732 0 14C0 6.26801 6.49187 0 14.5 0C22.5081 0 29 6.26801 29 14Z" fill="#2B2E2E"></path>
                            <path d="M6.68 15.36V11.64H21.6V15.36H6.68Z" fill="white"></path>
                       </svg>
                    </button>
    
                    <span class="product-bundle__item__quantity-selector__qty qty-value">${qty}</span>
                    <button class="product-bundle__item__quantity-selector__btn qty-btn plus">
                        <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M29 14C29 21.732 22.5081 28 14.5 28C6.49187 28 0 21.732 0 14C0 6.26801 6.49187 0 14.5 0C22.5081 0 29 6.26801 29 14Z" fill="#3F6D73"></path>
                            <path d="M12.6 21.24V15.36H6.68V11.64H12.6V5.72H16.32V11.64H22.2V15.36H16.32V21.24H12.6Z" fill="white"></path>
                        </svg>
                    </button>
                </div>
            </td>
           
            <td style="text-align: right; padding: 8px; border-bottom: 1px solid #000;">
                <button class="delete-btn" style="cursor: pointer; border:none;background: transparent;"><svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 9.00006V18.4001C17.5 18.7315 17.2314 19.0001 16.9 19.0001H4.1C3.76863 19.0001 3.5 18.7315 3.5 18.4001V9.00006" stroke="#2B2E2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.5 15.0001V9.00006" stroke="#2B2E2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.5 15.0001V9.00006" stroke="#2B2E2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19.5 5H14.5M14.5 5V1.6C14.5 1.26863 14.2314 1 13.9 1H7.1C6.76863 1 6.5 1.26863 6.5 1.6V5M14.5 5H6.5M1.5 5H6.5" stroke="#2B2E2E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg></button>
            </td>`;
            // Attach event listeners after row is inserted into DOM
            setTimeout(() => {
                row.querySelector('.minus').addEventListener('click', () => {
                    if (qty > 1) {
                        qty--;
                        row.querySelector('.qty-value').textContent = qty;
                        qtyElement.dataset.value = qty; // Update the actual dataset value
                        updateQuantity(qtyElement, qty);
                    }
                });

                row.querySelector('.plus').addEventListener('click', () => {

                    const ctaElement = document.querySelector('.product-bundle__cta');

                    if (ctaElement && !ctaElement.classList.contains('product-bundle__cta--active')) {
                        qty++;
                        row.querySelector('.qty-value').textContent = qty;
                        qtyElement.dataset.value = qty;
                        updateQuantity(qtyElement, qty);
                    }
                });

                row.querySelector('.delete-btn').addEventListener('click', () => {
                    if(!item.classList.contains('static')) {
                        row.remove();
                        removeItem(item);
                    }
                });
            }, 0);

            tbody.appendChild(row);
        });

        table.appendChild(tbody);
        modalBody.appendChild(table);
    };

    const qtyDecrement = (qty) => {
        const currentValue = parseInt(qty.dataset.value);
        if (currentValue > 0) {
            updateQuantity(qty, currentValue - 1);
            document.querySelectorAll(".product-bundle-v3__item__summery").forEach((buttonElement) => {
                buttonElement.classList.add("blink-zoom-button");

                // Remove class after animation ends to allow re-triggering
                setTimeout(() => {
                    buttonElement.classList.remove("blink-zoom-button");
                }, 1500);
            });
        }
    };

    const qtyIncrement = (qty) => {
        const currentValue = parseInt(qty.dataset.value);
        const maxQuantity = parseInt(qty.dataset.maxQuantity);
        const totalQty = getTotalQty() - currentValue;

        if (currentValue < maxQuantity && (bundleLimit === 0 || totalQty <= bundleLimit)) {
            updateQuantity(qty, currentValue + 1);
            document.querySelectorAll(".product-bundle-v3__item__summery").forEach((buttonElement) => {
                buttonElement.classList.add("blink-zoom-button");

                // Remove class after animation ends to allow re-triggering
                setTimeout(() => {
                    buttonElement.classList.remove("blink-zoom-button");
                }, 1500);
            });
        }
    };

    const getTotalQty = () => {
        return Array.from(node.querySelectorAll('.product-bundle__item--active [data-quantity]'))
            .reduce((acc, qty) => acc + parseInt(qty.dataset.value), 0);
    };

    const selectItem = () => {
        document.querySelectorAll('.product-bundle__item').forEach(item => {
            item.addEventListener('click', () => {
                const qty = item.querySelector('[data-quantity]');
                if (parseInt(qty.dataset.value) === 0) {
                    updateQuantity(qty, 0);
                }
            });
        });
    };

    const hitImage = () => {
        document.querySelectorAll('.product-bundle__item__image-wrapper').forEach(item => {
            item.addEventListener('click', () => {
                const aa = item.nextElementSibling;
                const bb = aa.nextElementSibling;
                const qty = bb.querySelector('[data-quantity]');
                const currentValue = parseInt(qty.dataset.value);
                updateQuantity(qty, currentValue + 1);
            });
        });
    }

    const removeItem = (item) => {
        const qty = item.querySelector('[data-quantity]');
        updateQuantity(qty, 0);
    };

    const updatePrice = () => {
        const activeItems = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]'));
        const totalQty = activeItems.reduce((acc, product) => acc + parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value), 0);
        const currentDiscount = (DISCOUNTS.filter((discount) => totalQty >= discount.minimumItems && discount.amount > 0)?.pop() || null);
        const discountFraction = (currentDiscount?.amount || 0) / 100;

        const total = activeItems.reduce((acc, product) => {
            const productData = JSON.parse(product.textContent);
            const price = parseFloat(productData.price);
            const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);
            return (!isNaN(price) && !isNaN(qty)) ? acc + price * qty * (1 - discountFraction) : acc;
        }, 0) / 100;

        const regex = /{{(.*?)}}/;
        const match = regex.exec(window.bundleStrings.currency_rules);
        const extractedStringWhite = match[1];
        const extractedString = extractedStringWhite.replaceAll(' ', '');

        let formattedTotalWithCurrency = ''
        let formattedTotal = ''
        let formattedTotalWithCurrencyDiscount = ''
        if (extractedString === 'amount_with_comma_separator'){
            formattedTotal = total.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            formattedTotalWithCurrency = window.bundleStrings.currency_rules.replace('{{amount_with_comma_separator}}', formattedTotal);
        }
        if (extractedString === 'amount_no_decimals_with_space_separator'){
            formattedTotal = total.toLocaleString('cs', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
            formattedTotalWithCurrency = window.bundleStrings.currency_rules.replace('{{ amount_no_decimals_with_space_separator }}', formattedTotal);
        }

        if (extractedString === 'amount_no_decimals'){
            formattedTotal = total.toLocaleString('se-SV', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            formattedTotalWithCurrency = window.bundleStrings.currency_rules.replace('{{amount_no_decimals}}', formattedTotal);
        }

        if (extractedString === 'amount'){
            formattedTotal = total.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            formattedTotalWithCurrency = window.bundleStrings.currency_rules.replace('{{amount}}', formattedTotal);
        }
        const threshold = bundleMinimumItems > 0 ? bundleMinimumItems : 5;

        Array.from(document.querySelectorAll('[data-total-price]')).forEach((element) => {
            element.innerHTML = `${formattedTotalWithCurrency}`; /*total === 0 ? defaultPriceMessage : `${formattedTotalWithCurrency}`;*/
            element.classList.toggle('product-bundle__price--discount', totalQty >= threshold);
        });

        Array.from(document.querySelectorAll('[data-compare-price]')).forEach((comparePriceElement) => {
            comparePriceElement.classList.toggle('product-bundle__price-compare--active', totalQty >= threshold);
            if (totalQty >= threshold) {
                if (extractedString === 'amount_with_comma_separator') {
                    let formattedTotalDiscounbt = (total / (1 - discountFraction)).toLocaleString('da-DK', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    formattedTotalWithCurrencyDiscount = window.bundleStrings.currency_rules.replace('{{amount_with_comma_separator}}', formattedTotalDiscounbt);
                }
                if (extractedString === 'amount_no_decimals') {
                    let formattedTotalDiscounbt = (total / (1 - discountFraction)).toLocaleString('se-SV', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    formattedTotalWithCurrencyDiscount = window.bundleStrings.currency_rules.replace('{{amount_no_decimals}}', formattedTotalDiscounbt);
                }
                if (extractedString === 'amount') {
                    let formattedTotalDiscounbt = (total / (1 - discountFraction)).toLocaleString('en-GB', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
                    formattedTotalWithCurrencyDiscount = window.bundleStrings.currency_rules.replace('{{amount}}', formattedTotalDiscounbt);
                }
                if (extractedString === 'amount_no_decimals_with_space_separator') {
                    let formattedTotalDiscounbt = (total / (1 - discountFraction)).toLocaleString('cs', {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0
                    });
                    formattedTotalWithCurrencyDiscount = window.bundleStrings.currency_rules.replace('{{ amount_no_decimals_with_space_separator }}', formattedTotalDiscounbt);
                }
                comparePriceElement.textContent = `${formattedTotalWithCurrencyDiscount}`;
            }
        });

        Array.from(document.querySelectorAll('[data-discount-percentage]')).forEach((discountPercentageElement) => {

            const discFirst = document.querySelector('[data-discount-first]');
            const discSecond = document.querySelector('[data-discount-second]');
            const discThird = document.querySelector('[data-discount-third]');

            percCont.classList.toggle('light',totalQty < threshold);

            if (bundleLimit > 0 ) {
                if (discountFraction !== 0) {
                    discountPercentageElement.classList.toggle('product-bundle__percentage--active', totalQty >= threshold);
                    discountPercentageElement.textContent = `${discountFraction * 100}%`;
                }
            } else {
                if(!bundleMealsLimit) {
                    
                discFirst.classList.toggle('product-mix-bundle__percentage--active', discountFraction === DISCOUNTS[0].amount / 100);
                discSecond.classList.toggle('product-mix-bundle__percentage--active', discountFraction === DISCOUNTS[1].amount / 100);
                discThird.classList.toggle('product-mix-bundle__percentage--active', discountFraction === DISCOUNTS[2].amount / 100);
                }
            }
        });

    };

    const updateMinimumAmount = () => {
        const totalQty = Array.from(node.querySelectorAll('.product-bundle__item--active [data-quantity]'))
            .reduce((acc, qty) => acc + parseInt(qty.dataset.value), 0);
        const currentDiscount = (DISCOUNTS.filter((discount) => totalQty >= discount.minimumItems && discount.amount > 0)?.pop() || null);
        const nextDiscount = currentDiscount ? DISCOUNTS[DISCOUNTS.indexOf(currentDiscount) + 1] : DISCOUNTS.find((discount) => discount.amount > 0);
        const discountFraction = (currentDiscount?.amount || 0) / 100;
        let message;
        const totalMeals = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]'))
            .reduce((acc, product) => {
                const productData = JSON.parse(product.textContent);
                const meals = parseInt(productData.meals);
                const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);

                if (!isNaN(meals) && !isNaN(qty)) {
                    return acc + meals * qty;
                } else {
                    return acc;
                }
            }, 0);

        if ((bundleMealsLimit !== 0 || !unitCounter) && bundleLimit <= 0) {
            const counterBox = document.querySelector('.product-bundle__select__text.meals');

            if (bundleMealsLimit - totalMeals <= 0) {
                counterBox.classList.remove("hidden");
                message = window.bundleStrings.selectAtLeastXMeals.replace(
                    "%%ITEMS%%",
                    `<span style="color:#ff7269;font-size: 19px;">${bundleMealsLimit - totalMeals}</span>`
                );
            
            } else {
                message = window.bundleStrings.selectAtLeastXMeals.replace("%%ITEMS%%", bundleMealsLimit - totalMeals);
            }

        } else if (bundleLimit > 0) {
            if (bundleLimit - totalQty === 0) {
                const discountPercentageElement = document.querySelector('[data-discount-percentage]');
                let discountPercentage = discountPercentageElement.textContent;
                discountPercentage = discountPercentage.replace("%", "");

                message = window.bundleStrings.receivingDiscount.replace('%%DISCOUNT%%', discountPercentage);

            } else {

                message = window.bundleStrings.selectAtLeastXItems.replace("%%ITEMS%%", bundleLimit - totalQty);

            }
        } else if (unitCounter){
                let currentDiscountPortions = '';
            if (unitCounter === 'portions') {
                currentDiscountPortions = (DISCOUNTS.filter((discount) => totalMeals >= discount.minimumItems && discount.amount > 0)?.pop() || null);
            } else {
                currentDiscountPortions = (DISCOUNTS.filter((discount) => totalQty >= discount.minimumItems && discount.amount > 0)?.pop() || null);
            }
            const nextDiscountPortions = currentDiscountPortions ? DISCOUNTS[DISCOUNTS.indexOf(currentDiscountPortions) + 1] : DISCOUNTS.find((discount) => discount.amount > 0);
            const discountFractionPortions = (currentDiscountPortions?.amount || 0) / 100;

            if (unitCounter === 'portions') {
                message = nextDiscountPortions
                    ? window.bundleStrings.selectXMorePortionsToGetYDiscount
                        .replace("%%ITEMS%%", nextDiscountPortions.minimumItems - totalMeals)
                        .replace("%%DISCOUNT%%", nextDiscountPortions.amount)
                    : window.bundleStrings.receivingDiscount.replace("%%DISCOUNT%%", currentDiscountPortions.amount);
            }
            if (unitCounter === 'items') {
                message = nextDiscount
                    ? window.bundleStrings.selectXMoreItemsToGetYDiscount
                        .replace("%%ITEMS%%", nextDiscount.minimumItems - totalQty)
                        .replace("%%DISCOUNT%%", nextDiscount.amount)
                    : window.bundleStrings.receivingDiscount.replace("%%DISCOUNT%%", currentDiscount.amount);
            }

            Array.from(document.querySelectorAll('[data-discount-percentage]')).forEach((discountPercentageElement) => {

                const discFirst = document.querySelector('[data-discount-first]');
                const discSecond = document.querySelector('[data-discount-second]');
                const discThird = document.querySelector('[data-discount-third]');

                percCont.classList.toggle('light',totalMeals < jsonBundleData[unitCounter][0].minimumItems);

                if (totalMeals < jsonBundleData[unitCounter][0].minimumItems) {
                    if (discountFractionPortions !== 0) {
                        discountPercentageElement.classList.toggle('product-bundle__percentage--active', totalMeals >= jsonBundleData[unitCounter][0].minimumItems);
                        discountPercentageElement.textContent = `${discountFractionPortions * 100}%`;
                    }
                } else {
                    discFirst.classList.toggle('product-mix-bundle__percentage--active', discountFractionPortions === DISCOUNTS[0].amount / 100);
                    discSecond.classList.toggle('product-mix-bundle__percentage--active', discountFractionPortions === DISCOUNTS[1].amount / 100);
                    discThird.classList.toggle('product-mix-bundle__percentage--active', discountFractionPortions === DISCOUNTS[2].amount / 100);
                }
            });
        }

        const discountStepMessage = window.bundleStrings.discountStep.replace('%%STEP%%', (currentDiscount || DISCOUNTS[0]).step);

        const updateElement = (element, textClass, stickyClass, message) => {
            const selectTextElement = document.querySelector('.product-bundle__select__text');
            const stickyElement = document.querySelector('.product-bundle__select__text-sticky');
            const hasDiscount = totalQty >= bundleMinimumItems;
            const computedStyle = window.getComputedStyle(selectTextElement);

            stickyElement.style.color = computedStyle.color;

            element.parentElement.classList.toggle('product-bundle__select--discount', hasDiscount);

            if (element.classList.contains(stickyClass)) {
                element.classList.toggle(`${stickyClass}--discount`, hasDiscount);
            }
            element.innerHTML = message;
        };

        Array.from(document.querySelectorAll('[data-minimum-amount]')).forEach((minimumElement) => {
            updateElement(
                minimumElement,
                'product-bundle__select__text', 'product-bundle__sticky__select__text',
                message,
            );
        });

        Array.from(document.querySelectorAll('[data-minimum-meal]')).forEach((minimumElement) => {
            updateElement(
                minimumElement,
                'product-bundle__select__text', 'product-bundle__sticky__select__text',
                message,
            );
        });

        Array.from(document.querySelectorAll('[data-discount-step]')).forEach((discountStep) => {
            updateElement(
                discountStep,
                'product-bundle__select__discount-step', 'product-bundle__sticky__select__discount-step',
                discountStepMessage,
            );
        });
    };

    const updateTotalAmountQty = () => {
        const totalQty = Array.from(node.querySelectorAll('.product-bundle__item--active'))
            .filter(item => !item.classList.contains('static'))  // Filter out items with class 'static'
            .reduce((acc, qty) => acc + parseInt(qty.querySelector('[data-quantity]').dataset.value), 0);


        const replacedMessage = window.bundleStrings.xItemsSelected.replace('%%ITEMS%%', totalQty);

        if(bundleMealsLimit === 0 ) {
            Array.from(document.querySelectorAll('[data-total-selected-amount]'))
                .forEach((element) => {
                    element.textContent = totalQty;
                });
        }
        Array.from(document.querySelectorAll('[data-total-selected-amount-sticky]'))
            .forEach((element) => {
                element.textContent = totalQty + ' ' + replacedMessage;
            });

        // Update data-item-count element
        const itemCountElement = document.querySelector('[data-item-count]');
        if (itemCountElement) {
            const originalText = itemCountElement.textContent.replace(/\(\d+\)$/, '').trim(); // Remove the number at the end
            itemCountElement.textContent = totalQty > 0 ? `${originalText} (${totalQty})` : originalText;
        }
    };

    const mealCalculation = () => {
        const totalMeals = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]'))
            .reduce((acc, product) => {
                const productData = JSON.parse(product.textContent);
                const meals = parseInt(productData.meals);
                const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);

                if (!isNaN(meals) && !isNaN(qty)) {
                    return acc + meals * qty;
                } else {
                    return acc;
                }
            }, 0);
        const mealCount = Math.floor(totalMeals / 6);
        const extraMeals = totalMeals % 6;
        const message = window.bundleStrings.mealCount;
        const replacedMessage = message.replace('%%DAYS%%', mealCount).replace('%%EXTRA%%', extraMeals);

        Array.from(document.querySelectorAll('[data-meals-count]'))
            .forEach((element) => {
                if (mealCount > 0 || extraMeals > 0){
                    element.classList.remove('hidden');
                    element.textContent = replacedMessage;
                } else {
                    element.classList.add('hidden');
                }
            });

    };



    const updateCta = () => {

        const totalMeals = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]'))
            .reduce((acc, product) => {
                const productData = JSON.parse(product.textContent);
                const meals = parseInt(productData.meals);
                const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);
                if (!isNaN(meals) && !isNaN(qty)) {
                    return acc + meals * qty;
                } else {
                    return acc;
                }
            }, 0);


        const totalQty = Array.from(node.querySelectorAll('.product-bundle__item--active [data-quantity]'))
            .reduce((acc, qty) => acc + parseInt(qty.dataset.value), 0);

        const threshold = bundleMinimumItems > 0 ? bundleMinimumItems : 1;

        if( unitCounter) {
            if (unitCounter === "portions"){
                Array.from(document.querySelectorAll('[data-total-selected-amount]'))
                    .forEach((element) => {
                        element.textContent = totalMeals;
                    });
                Array.from(document.querySelectorAll('[data-bundle-cta]')).forEach(cta => {
                    const label = cta.querySelector('[data-bundle-cta-label]');
                    const isActive = totalMeals >= jsonBundleData[unitCounter][0].minimumItems;
                    cta.classList.toggle('product-bundle__cta--active', isActive);
                    label.textContent = window.bundleStrings[isActive ? 'addToCart' : 'chooseFlavors'];
                });
            } else  {
                Array.from(document.querySelectorAll('[data-bundle-cta]')).forEach(cta => {
                    const label = cta.querySelector('[data-bundle-cta-label]');
                    const isActive = totalQty >= jsonBundleData[unitCounter][0].minimumItems;
                    cta.classList.toggle('product-bundle__cta--active', isActive);
                    label.textContent = window.bundleStrings[isActive ? 'addToCart' : 'chooseFlavors'];
                });

            }
        }
        else if(bundleMealsLimit !== 0) {
            Array.from(document.querySelectorAll('[data-total-selected-amount]'))
                .forEach((element) => {
                    element.textContent = totalMeals;
                });
            Array.from(document.querySelectorAll('[data-bundle-cta]')).forEach(cta => {
                const label = cta.querySelector('[data-bundle-cta-label]');
                const isActive = totalMeals >= bundleMealsLimit;
                cta.classList.toggle('product-bundle__cta--active', isActive);
                label.textContent = window.bundleStrings[isActive ? 'addToCart' : 'chooseFlavors'];
            });
            if (totalMeals >= bundleMealsLimit){
                Array.from(document.querySelectorAll('[data-increment]'))
                    .forEach((element) => {
                        element.disabled = true;
                    });
            } else {
                Array.from(document.querySelectorAll('[data-increment]'))
                    .forEach((element) => {
                        element.disabled = false;
                    });
            }
        } else {
            Array.from(document.querySelectorAll('[data-bundle-cta]')).forEach(cta => {
                const label = cta.querySelector('[data-bundle-cta-label]');
                const isActive = totalQty >= threshold;
                cta.classList.toggle('product-bundle__cta--active', isActive);
                label.textContent = window.bundleStrings[isActive ? 'addToCart' : 'chooseFlavors'];
            });
        }
    };

    const addToCart = async (event) => {
        event.preventDefault();
        const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const items = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]')).map((product) => {
            const productData = JSON.parse(product.textContent);
            const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);
            const title = document.querySelector('.product-bundle__title')?.textContent.trim() || '';
            return {
                id: productData.id,
                quantity: qty,
                properties: {
                    "__bundle": bundleParentId,
                    "__bundle_name": title
                }
            };
        });

        const totalMeals = Array.from(node.querySelectorAll('.product-bundle__item--active [data-product]'))
            .reduce((acc, product) => {
                const productData = JSON.parse(product.textContent);
                const meals = parseInt(productData.meals);
                const qty = parseInt(product.closest('.product-bundle__item').querySelector('[data-quantity]').dataset.value);

                if (!isNaN(meals) && !isNaN(qty)) {
                    return acc + meals * qty;
                } else {
                    return acc;
                }
            }, 0);

        const totalQty = items.reduce((total, item) => total + item.quantity, 0);
        const threshold = bundleMinimumItems > 0 ? bundleMinimumItems : 1;

        if (totalQty < threshold || totalMeals < bundleMealsLimit) {
            return; // Exit the function if the total quantity is less than the threshold
        }

        const data = {
            items: items
        };

        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        if (cartDrawer) {
            data.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
            data.sections_url = window.location.pathname;
            cartDrawer.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(data);

        const cartResponse = await fetch('/cart.js');
        const cartData = await cartResponse.json();

        fetch(window.routes.cart_add_url + `.js`, config)
            .then(response => response.json())
            .then(data => {

                if (cartDrawer) {
                    cartDrawer.classList.remove('is-empty');
                    cartDrawer.renderContents(data);
                }

            })
            .catch((error) => {
                console.error('Error:', error);
            });

    };

    const init = () => {
        stickyCta();
        selectItem();
        hitImage();
        updateTotalAmountQty();

        node.querySelectorAll('[data-remove-item]').forEach((removeButton) => {
            removeButton.addEventListener('click', (event) => {
                event.stopPropagation();
                removeItem(removeButton.closest('.product-bundle__item'));
            });
        });

        node.querySelectorAll('[data-quantity]').forEach((qty) => {
            const parent = qty.closest('.product-bundle__item__quantity-selector');
            const decrease = parent.querySelector('[data-decrement]');
            const increase = parent.querySelector('[data-increment]');

            decrease.addEventListener('click', (event) => {
                event.stopPropagation();
                qtyDecrement(qty);
            });

            increase.addEventListener('click', () => qtyIncrement(qty));
        });

        document.querySelectorAll('[data-bundle-cta]').forEach((cta) => {
            cta.addEventListener('click', addToCart);
        });

        if (document.querySelector('[data-bundle-order-summary]')){
            document.querySelector('[data-bundle-order-summary]').addEventListener('click', (event) => {
                orderSummmery('SelectedProductModal');
            });
        }
        if (document.querySelector('[data-bundle-order-summary-mobile]')){
            document.querySelector('[data-bundle-order-summary-mobile]').addEventListener('click', (event) => {
                orderSummmery('SelectedProductModalMobile');
            });
        }

    };

    init();
})();
